module.exports = __webpack_public_path__ + "img/icon-needs-ecosystem.047098e8.svg";